const SLOW_SCAN_TIMEOUT_MS = 10_000;
let slowScanTimer = null;
let slowScanTimerCallback = null;

let slowReminderShown = false;
let slowScanBanner = null;
let slowScanText = null;
let currentSessionId = null;
const timeouts = {
	loading: 5_000,
	initiating: 20_000,
	clicking: 10_000,
	retrieving: 10_000,
	adjusted: 10_000
};

const pageLoadTime = Date.now();

const states = {
  LOADING: "loading",
	INITIATED : "initiated",
	CLICKED: "clicked",
	RETRIEVED: "retrieved",
	SUCCESS: "success",
	FAILED: "failed",
};
const events = {
  LOAD_DONE: "LOAD_DONE",
	CLICK: "CLICK",
	PENDING: "PENDING",
	SUCCESS: "SUCCESS",
	FAILED: "FAILED",
	TIMEOUT: "TIMEOUT",
};
const transitions = {
 [states.LOADING]: {
    [events.LOAD_DONE]: states.INITIATED,
    [events.TIMEOUT]: states.LOADING,
  },
  [states.INITIATED]: {
    [events.CLICK]: states.CLICKED,
    [events.PENDING]: states.RETRIEVED,
    [events.TIMEOUT]: states.INITIATED,
  },

  [states.CLICKED]: {
    [events.PENDING]: states.RETRIEVED,
    [events.TIMEOUT]: states.CLICKED,
  },

  [states.RETRIEVED]: {
    [events.SUCCESS]: states.SUCCESS,
    [events.FAILED]: states.FAILED,
    [events.TIMEOUT]: states.RETRIEVED,
  },

  [states.SUCCESS]: {},

  [states.FAILED]: {},
};

function resetUI() {
  if (slowScanTimer) {
    clearTimeout(slowScanTimer);
    slowScanTimer = null;
  }

  slowReminderShown = false;

  if (slowScanBanner) {
    slowScanBanner.classList.add("d-none");
  }
}

function startTimer(
  message,
  timeout
) {
  slowScanTimerCallback = () => {

      if (!slowScanBanner) return;

      if (slowScanText) {
        slowScanText.textContent = message;
      }

      slowScanBanner.classList.remove(
        "d-none"
      );

  }
  slowScanTimer = setTimeout(slowScanTimerCallback, timeout);

}
function retryLast(timeout) {
  if (slowScanTimer) {
    clearTimeout(slowScanTimer);
  }
  slowScanTimer = setTimeout(slowScanTimerCallback, timeout);
}


function delay(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}


const statesConfig = {

  [states.LOADING]: {
    onEnter() {
      resetUI();
      startTimer(
        "Hmm 🤔 this is taking longer than expected. Loading QR code… please wait.",
        timeouts.adjusted
      );
    }
  },
  [states.INITIATED]: {
    onEnter() {
		resetUI();
		startTimer("Hmm 🤔 this is taking longer than expected. Try scanning the QR code again to continue.", timeouts.initiating);
    }
  },

  [states.CLICKED]: {
    onEnter() {
		resetUI();
    	startTimer("📱 Please confirm the request in your wallet to continue.", timeouts.clicking);
    }
  },

  [states.RETRIEVED]: {
    onEnter() {
		resetUI();
    	startTimer("Almost there ⏳ Waiting for your wallet to finish the verification.", timeouts.retrieving);
    }
  },

  [states.SUCCESS]: {
    onEnter() {
      resetUI();
      window.location.href =
        "/success.html?sessionId=" + currentSessionId;
    }
	},

	[states.FAILED]: {
		onEnter() {
			resetUI();
			window.location.href =
				"/fail.html?sessionId=" + currentSessionId;
		}
	}

};

function createMachine({
  initialState,
  transitions,
  states
}) {

  let state = initialState;

  function runEnter(newState) {
    const cfg = states[newState];
    if (cfg && cfg.onEnter) {
      cfg.onEnter();
    }
	else {
	  console.warn("Unknown state", newState);
	}
  }

  function send(event) {

    const next =
      transitions[state]?.[event] ?? state;

    if (next === state) {
      console.warn("No transition", state, event);
    } else {
      console.log(state, "→", next, "by", event);
    }
    const prev = state;
    state = next;
    runEnter(state);
  }

  function getState() {
    return state;
  }

  runEnter(state);

  return { send, getState };
}


async function fetchShowQrCode() {

	console.log("Window loaded");

	const params = new URLSearchParams(window.location.search);
	const tenant = params.get("tenant");


	slowScanBanner = document.getElementById("slowScanAlert");
	const slowScanCloseBtn =
	  document.getElementById("slowScanClose");
	slowScanText =
    document.getElementById("slowScanText");
	if (slowScanCloseBtn) {
	slowScanCloseBtn.addEventListener("click", resetUI);
	}


  fetch("/api/config", {
    method: "GET",
    headers: { Accept: "application/json" },
    cache: "no-store"
  })
    .then(res => (res.ok ? res.json() : null))
    .then(configData => {
      if (!configData) return;

      if (configData.loadingTimeout != null) {
        timeouts.loading = configData.loadingTimeout;
      }
      if (configData.initiatingTimeout != null) {
        timeouts.initiating = configData.initiatingTimeout;
      }
      if (configData.clickingTimeout != null) {
        timeouts.clicking = configData.clickingTimeout;
      }
      if (configData.retrievingTimeout != null) {
        timeouts.retrieving = configData.retrievingTimeout;
      }

      const elapsed = Date.now() - pageLoadTime;
      timeouts.adjusted = Math.max(0, timeouts.loading - elapsed);
      console.log("Adjusted loading timeout:", timeouts.adjusted, "ms", "(elapsed since page load:", elapsed, "ms)");
      if (machine.getState() === states.LOADING) {
        retryLast(timeouts.adjusted);
      }
    })
    .catch(() => {
      console.warn("Config fetch failed, using default timeout:", SLOW_SCAN_TIMEOUT_MS);
    });

    console.log("Waiting for test log...");

    delay(8000).then(() => {
      console.log("8 seconds later ...");
    });


	const machine = createMachine({
	initialState: states.LOADING,
	transitions,
	states: statesConfig,
	});


	let url = "/api/verification";

	if (tenant) {
	url += "?tenant=" + encodeURIComponent(tenant);
	}


	const response = await fetch(url, {
	method: "GET",
	headers: { Accept: "application/json" },
	cache: "no-store"
	});


	if (!response.ok) {
	throw new Error("HTTP error " + response.status);
	}


	const data = await response.json();
	machine.send(events.LOAD_DONE);

	const requestUri = data.requestUri;
	const qrImageUrl = data.qrImageUrl;
	const sessionId = data.sessionId;
	currentSessionId = sessionId;

	const qrImage = document.getElementById("qrImage");
	const qrBox = document.getElementById("qrBox");


	if (qrImage) {

		qrImage.onload = function () {
			qrImage.classList.remove(
			"placeholder",
			"placeholder-qr"
			);

			qrImage.parentElement.classList.remove(
			"placeholder-glow"
			);
		};

	qrImage.src = qrImageUrl;
	}


	if (qrBox) {

		qrBox.href = requestUri;

  qrBox.addEventListener("click", async (e) => {
    e.preventDefault();

			machine.send(events.CLICK);

    try {
      await navigator.clipboard.writeText(requestUri);
    } catch (err) {
      console.error("Clipboard write failed:", err);
    }
    copyMessage.classList.remove("opacity-0");
    copyMessage.classList.add("opacity-100");

    setTimeout(() => {
      copyMessage.classList.remove("opacity-100");
      copyMessage.classList.add("opacity-0");
    }, 1500);

    const isInIframe = window.self !== window.top;

    if (isInIframe) {
      window.parent.postMessage(
        {
          type: "OPEN",
          url: requestUri
        },
        "*"
      );
    } else {
      window.location.href = requestUri;
    }
  }
  );
}


    const evtSource = new EventSource("/api/status/" + sessionId);
		evtSource.onmessage = (event) => {

		let message = JSON.parse(event.data);


		if (message.type === "PENDING") {
			machine.send(events.PENDING);
		}


		if (message.type === "SUCCEEDED") {
			machine.send(events.SUCCESS);
		}


		if (message.type === "FAILED") {
			machine.send(events.FAILED);
		}

		};
	}

function fetchShowQrCodeOnLoad() {
	window.addEventListener("load",fetchShowQrCode);
	}


fetchShowQrCodeOnLoad();
